import { Component, type ErrorInfo, type ReactNode } from 'react';

interface RenderErrorBoundaryProps {
  readonly children: ReactNode;
}

interface RenderErrorBoundaryState {
  readonly error?: Error;
}

export class RenderErrorBoundary extends Component<RenderErrorBoundaryProps, RenderErrorBoundaryState> {
  override state: RenderErrorBoundaryState = {};

  static getDerivedStateFromError(error: Error): RenderErrorBoundaryState {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('The Bee Hive renderer failed', error, info);
  }

  override render() {
    if (this.state.error) {
      return (
        <div className="absolute inset-0 grid place-items-center bg-hive-cream px-4 text-hive-ink">
          <section className="glass-panel max-w-md rounded-lg p-5 text-center">
            <h1 className="font-display text-2xl font-bold">Renderer paused</h1>
            <p className="mt-2 text-sm font-medium text-hive-ink/70">
              The town simulation is still packaged, but your browser reported a graphics error. Try refreshing once, then check WebGL is enabled.
            </p>
          </section>
        </div>
      );
    }

    return this.props.children;
  }
}
